import React from 'react'
import {Icon} from '@chakra-ui/react'

const PodsIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" {...props}>
            <path
                d="M12 2C6.49 2 2 6.49 2 12V19C2 20.65 3.35 22 5 22H6C7.65 22 9 20.65 9 19V16C9 14.35 7.65 13 6 13H4V12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12V13H18C16.35 13 15 14.35 15 16V19C15 20.65 16.35 22 18 22H19C20.65 22 22 20.65 22 19V12C22 6.49 17.51 2 12 2ZM6 15C6.55 15 7 15.45 7 16V19C7 19.55 6.55 20 6 20H5C4.45 20 4 19.55 4 19V15H6ZM20 19C20 19.55 19.55 20 19 20H18C17.45 20 17 19.55 17 19V16C17 15.45 17.45 15 18 15H20V19Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default PodsIcon
